<template>
	<router-view :key="$route.fullPath"></router-view>
</template>
<script>
import { mapGetters } from 'vuex';
import { GridsGetters } from '../../store/getters';
import { gridViewTypes } from '../../enums/gridViewTypes';
import { GridsPageActions } from '../../store/actions';
export default {
	name: 'GridsPage',
	computed: {
		...mapGetters({
			gridViews: [GridsGetters.GET_GRID_VIEWS],
		}),
		currentEntity() {
			return this.$route.params.pageName;
		},
	},
	watch: {
		currentEntity: function () {
			this.getCurrentGrid();
		},
	},
	created() {
		this.getCurrentGrid();
	},
	destroyed() {
		this.$store.dispatch(GridsPageActions.CLEAR);
	},
	methods: {
		getCurrentGrid() {
			let entityGrids = this.gridViews.filter(
				(grid) =>
					grid.Entity.Name === this.currentEntity &&
					grid.Type == gridViewTypes.Grids
			);
			//IsDefault is the pick of the current user, the api already worked out which view carries
			//it. It can sit on a global view somebody else created, so never filter by owner here.
			let defaultView = entityGrids.find((grid) => grid.IsDefault == true);
			if (defaultView) {
				this.$store.dispatch(
					GridsPageActions.LOAD_GRID_VIEW,
					defaultView
				);

				return defaultView;
			}

			let currentView = entityGrids.find((grid) => grid.UserId == null);
			if (!currentView) {
				currentView = this.gridViews.find(
					(grid) => grid.Entity.Name === this.currentEntity
				);
			}

			this.$store.dispatch(GridsPageActions.LOAD_GRID_VIEW, currentView);
			return currentView;
		},
	},
};
</script>
